const log = require('sesajstools/utils/log')
const { formatDate, formatTime, startOfDay } = require('sesajs-date')

// Useful constants to compute time left
const MINUTE = 60_000
const HOUR = MINUTE * 60
const DAY = HOUR * 24

/**
 * Retourne la différence entre deux date à mettre après fin|sera ouvert|fermé
 * @private
 * @param {Date} date1
 * @param {Date} date2
 * @return {string}
 */
function getDelayString (date1, date2) {
  const diff = Math.abs(date2 - date1)

  const days = Math.floor(diff / DAY)
  // if (days > 7) return getFormattedDate(date2)
  if (days > 1) return `dans ${days} j`
  // delai entre 0 et 2j, faut trancher entre aujourd'hui|demain|après-demain
  // l'heure est souvent minuit, pour lever l'ambiguïté on ajoute ou on retire une minute (pour répondre à 23h59 plutôt que demain à 00:00
  if (date2 > date1 && !date2.getMinutes()) {
    date2 = new Date(date2.getTime() - MINUTE)
  } else if (!date1.getMinutes()) {
    date1 = new Date(date1.getTime() + MINUTE)
  }
  const nbDays = Math.round((startOfDay(date2) - startOfDay(date1)) / DAY)
  const timeSuffix = `à ${formatTime({ date: date2, withoutSec: true }).replace(':', 'h')}`
  switch (nbDays) {
    case -2: return `avant-hier à ${timeSuffix}`
    case -1: return `hier à ${timeSuffix}`
    case 0: return date2 > date1 ? `à ${timeSuffix}` : timeSuffix
    case 1: return `demain ${timeSuffix}`
    case 2: return `après-demain ${timeSuffix}`
    default: {
      console.error(Error(`Cas non prévu dans getDelayString (délai de ${nbDays} jours)`), date1, date2)
      return `le ${formatDate(date2)} ${timeSuffix}`
    }
  }
}

module.exports = function ($rootScope, $scope, $api, $errors, $session, $toaster) {
  'ngInject'

  $scope.delayMessage = ''
  $scope.deadDelayMessage = ''

  function initialize () {
    // clear non-zapping
    $scope.$on('seance::finished', function () {
      log.debug('seance::finished dans widget seance')
      $scope.running = false
      // Reset non-zapping
      $rootScope.nonZapping = 0
      $rootScope.startedAt = null
    })
    $scope.$on('exercice::updated', function (event, isFinished) {
      if (isFinished) $scope.running = false
      $scope.$digest() // ça rafraîchit uniquement le $scope courant, $apply() les fait tous ($rootScope)
    })

    // init seance scope vars
    $scope.isFormateur = $session.isFormateur()
    $scope.running = false

    const debut = $scope.seance.dateDebut
    const fin = $scope.seance.dateFin
    if (debut && fin) {
      const today = new Date()
      if (debut < today && today < fin) {
        $scope.delayMessage = `Fin ${getDelayString(today, fin)}`
      } else if (today < debut) {
        // pas encore ouvert
        $scope.deadDelayMessage = `Sera ouvert ${getDelayString(today, debut)}`
        if (debut - today < 4 * HOUR) $scope.deadDelayMessage += ' (rafraîchir la page pour activer cette séquence si cette heure est passée)'
      } else {
        // trop tard (fin < today)
        $scope.deadDelayMessage = `Terminé depuis ${getDelayString(today, fin)}`
      }
    } else if (debut || fin) {
      console.error(Error('seance avec début ou fin mais pas les deux'), $scope.seance)
    }
    // log.debug('initialized scope widget seance', $scope)
  }

  $scope.doShowBilan = function (seance) {
    if ($scope.running) {
      $toaster.pop('Le bilan sera accessible une fois l’exercice terminé', 'error')
      return
    }
    $rootScope.$broadcast('seance::show-bilan', seance)
  }

  /**
   * Lance le chargement de la ressource (et start une séance)
   * @param {Seance} seance
   * @param {Exercice} exercice
   */
  $scope.doStart = function (seance, exercice) {
    if ($session.isFormateur()) {
      seance.start(exercice)
      return
    }

    if (exercice.isDisabled()) return

    if ($rootScope.nonZapping && $rootScope.startedAt) {
      const delay = Math.round((Date.now() - $rootScope.startedAt) / 1000)
      // console.log(`start exercice avec dernier exercice ouvert depuis ${delay}s et un non-zapping de ${$rootScope.nonZapping}s`)
      if (delay < $rootScope.nonZapping) {
        $toaster.pop(`Vous devez attendre encore ${$rootScope.nonZapping - delay}s avant de passer à un autre exercice.`, 'error')
        return
      }
    }

    // ok, on lance
    $scope.running = true
    seance.start(exercice)
  }

  initialize()
}
